
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 140 140"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"レイヤー 1"}},[_c('path',{attrs:{"d":"M91.11 67s-.39-8.45-4.9-13.64c-2.54-3.28-3.13-8.36-3.43-12.06s-2.63-31.15-2.63-31.15a6.54 6.54 0 001.11-1.57c0-.45-.73-1.36-1.12-2.35s-.8-1.65-.31-2.11a2.28 2.28 0 00.82-1.68 2 2 0 00-.76-1.17 3.65 3.65 0 00-1.48-.91C77.57.19 71.55 0 70 0s-7.63.2-8.48.36-2.23 1.46-2.23 2.09a2.39 2.39 0 00.83 1.67c.48.45.11 1.12-.3 2.1s-1.16 1.93-1.13 2.36 1.13 1.56 1.13 1.56-2.31 27.54-2.64 31.17-.87 8.79-3.4 12.09c-4.51 5.19-4.88 13.65-4.88 13.65v69.21a2.18 2.18 0 00.82 1.57 7.32 7.32 0 002.1 1.29 46.24 46.24 0 006.67.88h23.07a44.63 44.63 0 006.67-.89s2.92-1.11 2.92-2.86S91.11 67 91.11 67z","fill":"#2ca6e0"}}),_c('path',{attrs:{"fill":"none","d":"M0 0h140v140H0z"}})])])])
          )
        }
      }
    